import { useAppStore, type RenderStyle } from '@/stores/appStore';
import { Moon, Sun } from 'lucide-react';

const modes: { id: RenderStyle; label: string; Icon: typeof Moon }[] = [
  { id: 'dark', label: 'Dark', Icon: Moon },
  { id: 'light', label: 'Light', Icon: Sun },
];

export function StyleSwitcher() {
  const current = useAppStore((s) => s.worldState.renderStyle);
  const setStyle = useAppStore((s) => s.setRenderStyle);
  const activeScenario = useAppStore((s) => s.scenarioState.activeScenario);

  // Hide while a scenario is running so it never overlaps the Telemetry panel.
  if (activeScenario) return null;

  return (
    <div className="fixed top-4 right-4 z-50 flex gap-1 bg-[var(--switcher-bg)] backdrop-blur-sm border border-[var(--border)] rounded-lg p-1">
      {modes.map((m) => (
        <button
          key={m.id}
          onClick={() => setStyle(m.id)}
          className={`px-3 py-1.5 rounded-md text-xs font-medium transition-all flex items-center gap-1.5 ${
            current === m.id
              ? 'bg-[var(--switcher-active)] text-[var(--switcher-text)] border border-[var(--border)]'
              : 'text-[var(--text-muted)] hover:text-[var(--text-secondary)]'
          }`}
        >
          <m.Icon size={12} />
          {m.label}
        </button>
      ))}
    </div>
  );
}
